import moment from 'moment';

export const formatDateTime = (date: string) =>
  moment(date).format('DD.MM.YYYY, HH:mm');

export const formatDate = (date: string | Date) =>
  moment(date).format('DD.MM.YYYY');

export const API_DATE_FORMAT = 'YYYY-MM-DD';

export const toApiDate = (date: Date): string =>
  moment(date).format(API_DATE_FORMAT);

export const compareDates = (firstDate: string, secondDate: string): boolean =>
  moment(moment(firstDate).format('YYYY-MM-DD')).isSameOrAfter(
    moment(secondDate).format('YYYY-MM-DD')
  );
